import { 
  Filter, 
  ShieldCheck, 
  Package, 
  FlaskRound 
} from "lucide-react";

interface ServiceProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const Service = ({ icon, title, description }: ServiceProps) => {
  return (
    <div className="flex gap-4">
      <div className="flex-shrink-0 w-12 h-12 bg-primary rounded-full flex items-center justify-center">
        {icon}
      </div>
      <div>
        <h3 className="text-xl font-semibold mb-2 font-heading">{title}</h3>
        <p className="text-neutral-700">{description}</p>
      </div>
    </div>
  );
};

const ServicesSection = () => {
  const services = [
    {
      icon: <Filter className="text-xl text-white" />,
      title: "Seed Cleaning & Grading",
      description: "State-of-the-art equipment for precise cleaning and grading of all seed types."
    },
    {
      icon: <ShieldCheck className="text-xl text-white" />,
      title: "Seed Treatment",
      description: "Advanced treatment processes to enhance seed protection and performance."
    },
    {
      icon: <Package className="text-xl text-white" />,
      title: "Seed Packaging",
      description: "Custom packaging solutions to maintain seed viability and enhance shelf life."
    },
    {
      icon: <FlaskRound className="text-xl text-white" />,
      title: "Seed Testing",
      description: "Comprehensive testing services for germination rate, purity, and vigor."
    }
  ];

  return (
    <section id="services" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-primary font-medium">Our Services</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-6 font-heading">
              Advanced Seed Processing Solutions
            </h2>
            <p className="text-neutral-700 mb-8">
              We provide comprehensive seed processing services using cutting-edge 
              technology and industry best practices to ensure optimal seed quality 
              and performance.
            </p>
            
            <div className="space-y-6">
              {services.map((service, index) => (
                <Service 
                  key={index}
                  icon={service.icon}
                  title={service.title}
                  description={service.description}
                />
              ))}
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-6">
            <div>
              <img 
                src="https://images.unsplash.com/photo-1585598007006-47f1f80afb84?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8c2VlZCBwcm9jZXNzaW5nIGVxdWlwbWVudHx8fHx8fDE2OTc4Mzg5Njg&ixlib=rb-4.0.3&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=500" 
                alt="Seed processing equipment" 
                className="rounded-lg shadow-md w-full h-auto"
              />
            </div>
            <div className="mt-12">
              <img 
                src="https://images.unsplash.com/photo-1577639576759-a38a1ed09fe7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8c2VlZCBwcm9jZXNzaW5nIGVxdWlwbWVudHx8fHx8fDE2OTc4Mzg5ODE&ixlib=rb-4.0.3&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=500" 
                alt="Lab equipment for seed testing" 
                className="rounded-lg shadow-md w-full h-auto"
              />
            </div>
            <div className="-mt-8">
              <img 
                src="https://images.unsplash.com/photo-1598717873646-ba7e5ab01a39?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8c2VlZCBwcm9jZXNzaW5nIGVxdWlwbWVudHx8fHx8fDE2OTc4Mzg5OTY&ixlib=rb-4.0.3&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=500" 
                alt="Seed packaging process" 
                className="rounded-lg shadow-md w-full h-auto"
              />
            </div>
            <div>
              <img 
                src="https://images.unsplash.com/photo-1605000797499-95a51c5269ae?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8c2VlZCBwcm9jZXNzaW5nIGVxdWlwbWVudHx8fHx8fDE2OTc4MzkwMDk&ixlib=rb-4.0.3&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=500" 
                alt="Quality inspection" 
                className="rounded-lg shadow-md w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
